
import React, { Component } from 'react';

import {  Table, Drawer } from 'antd';
import moment from 'moment-timezone';
import { map } from 'lodash';
import ScrollArea from 'react-scrollbar';
import Loader from '../../../Common/Component/Loader';
import DataTable from './Datatable';
import {errorHandle} from "../../../Common/errorHandle";
import ZipcodeDrawer from './ZipcodeDrawer';
// const { Option } = Select;

// const schedule = [
// {
//   'area': 'SW1',
//   'zipcode': ['12', '13', '14'],
//   'monday': 5,
//   'tuesday': 5,
//   'wednesday': 5,
//   'thursday': 5,
//   'friday': 5,
//   'saturday': 5,
//   'sunday': 5
// },
// {
//   'area': 'SW2',
//   'zipcode': ['12', '13', '14'],
//   'monday': 5,
//   'tuesday': 5,
//   'wednesday': 5,
//   'thursday': 5,
//   'friday': 5,
//   'saturday': 5,
//   'sunday': 5
// },
// {
//   'area': 'SW3',
//   'zipcode': ['12', '13', '14'],
//   'monday': 5,
//   'tuesday': 5,
//   'wednesday': 5,
//   'thursday': 5,
//   'friday': 5,
//   'saturday': 5,
//   'sunday': 5
// },
// {
//   'area': 'SW4',
//   'zipcode': ['12', '13', '14'],
//   'monday': 5,
//   'tuesday': 5,
//   'wednesday': 5,
//   'thursday': 5,
//   'friday': 5,
//   'saturday': 5,
//   'sunday': 5
// }
// ]

class InitialCleaning extends Component {
  state = {
    calendar_data: [],
    new_cleaning: {
      field_office_uuid: '',
      cleaning_date: '',
      repeat: false,
    },
    delete_id: '',
    is_delete: false,
    // table:[],
    current_tab: 0,
    loader: false,
    openNav: {},
    is_zipcode_drawer: false

  }

  componentDidMount = () => {
    let { new_cleaning } = this.state;
    //Get Standrad Cleaning
    if (this.props.history.location.state) {

      new_cleaning = Object.assign(new_cleaning, { field_office_uuid: this.props.history.location.state.query.data.uuid })

      this.setState({
        new_cleaning
      })

      this.props.getIntialCleaning({ field_office__uuid: this.props.history.location.state.query.data.uuid });
      this.setState({
        loader: true
      })
    }

    try {
      this.props.getAllZipCodes({uuid: this.props.history.location.state.query.data.uuid});
      this.props.getAllInitialCleaningData({uuid: this.props.history.location.state.query.data.uuid})
      this.props.getNextTenDaysInitialCleaningData({uuid: this.props.history.location.state.query.data.uuid})
    } catch (e) {
      console.error(e);
    }
    
  }

  updateTableState(params) {
    const {record, day, action} = params;
    let updatedInitalCleaningData = {};
    switch (action) {
    case 'DECEREMENT':
      updatedInitalCleaningData = {...this.state.InitialCleaningData};
      if(updatedInitalCleaningData[record.area][day].num_of_cleans > 0) {
        updatedInitalCleaningData[record.area][day].num_of_cleans = updatedInitalCleaningData[record.area][day].num_of_cleans - 1;
      }
      this.setState({
        InitialCleaningData: updatedInitalCleaningData
      })
      break;
    case 'INCREMENT':
      updatedInitalCleaningData = {...this.state.InitialCleaningData};
      updatedInitalCleaningData[record.area][day].num_of_cleans = updatedInitalCleaningData[record.area][day].num_of_cleans + 1;
      this.setState({
        InitialCleaningData: updatedInitalCleaningData
      })
      break;
    default:
      console.log('no action')
    }

    this.setState({
      table: this.initialCleaningDataToTable(updatedInitalCleaningData)
    })

    let request_data = this.initialCleaningToSaveRequest(updatedInitalCleaningData);
    this.props.setUpdateHandlerState(request_data)
  }

  initialCleaningDataToTable = (InitialCleaningData) => {
    return Object.keys(InitialCleaningData || {}).map((key, i) => ({
      area: key,
      zipcode: InitialCleaningData[key].zip_code_set,
      uuids: ["mon","tues","wed","thurs","fri","sat","sun"].map(day => (InitialCleaningData[key][day].uuid)),
      monday: InitialCleaningData[key].mon.num_of_cleans,
      tuesday: InitialCleaningData[key].tues.num_of_cleans,
      wednesday: InitialCleaningData[key].wed.num_of_cleans,
      thursday: InitialCleaningData[key].thurs.num_of_cleans,
      friday: InitialCleaningData[key].fri.num_of_cleans,
      saturday: InitialCleaningData[key].sat.num_of_cleans,
      sunday: InitialCleaningData[key].sun.num_of_cleans,
      field_office: InitialCleaningData[key].field_office,
      i,
    }))
  }

  initialCleaningToSaveRequest = (InitialCleaningData) => {
    return Object.keys(InitialCleaningData || {}).map(key => {

      const tuple = InitialCleaningData[key];

      return ["mon","tues","wed","thurs","fri","sat","sun"].map(day => ({
        uuid: tuple[day].uuid,
        field_office: tuple.field_office,
        area: tuple.area,
        zip_codes: tuple.zip_codes,
        setup_day: day,
        num_of_cleans: tuple[day].num_of_cleans
      }))
    }).reduce((acc, curr) => {
      return [...acc, ...curr];
    }, []);
  }

  UNSAFE_componentWillReceiveProps = (props) => {

    if(props?.InitialCleaning?.renderCount > this.props?.InitialCleaning?.renderCount) {
      this.setState({
        is_zipcode_drawer: false,
      })
    }
    
    if(props?.InitialCleaning?.initial_cleaning_data?.results) {
      
      // if there is no major update in the props and refresh count is not updated then no need to rerender
      if(this.props.InitialCleaning === props.InitialCleaning && this.props?.refreshCount === props?.refreshCount) {
        return;
      }

      const InitialCleaningData = props?.InitialCleaning?.initial_cleaning_data?.results?.reduce(
        (acc, item) => {
          let zip_code_set = new Set([...(acc?.zip_codes_set || []), ...(item?.zip_codes || [])]);
          
          if(!acc[item.area]) {
            acc[item.area] = {
              ...item,
              [item.setup_day]: {num_of_cleans: item.num_of_cleans, uuid: item.uuid},
              zip_code_set,
            };
          } else {
            acc[item.area] = {
              ...acc[item.area],
              ...item,
              [item.setup_day]: {num_of_cleans: item.num_of_cleans, uuid: item.uuid},
              zip_code_set,
            };
          }
          return acc
        }
        ,{})
        
      const table = this.initialCleaningDataToTable(InitialCleaningData);


        
      this.setState({InitialCleaningData, table});
      let request_data = this.initialCleaningToSaveRequest(InitialCleaningData);
      this.props.setUpdateHandlerState(request_data);
    }

    if (props?.InitialCleaning?.next_10_days_initial_cleaning_data?.count > 0) {
      const next_10_days_initial_cleaning_data = props?.InitialCleaning?.next_10_days_initial_cleaning_data?.results?.reduce(
        (acc, item) => {
          if(!acc[item.base_initial_clean.area]) {
            acc[item.base_initial_clean.area] = {
              [item.cleaning_date] : item
            };
          } else {
            acc[item.base_initial_clean.area] = {
              ...acc[item.base_initial_clean.area],
              [item.cleaning_date] : item
            };
          }
          return acc
        }
        ,{})
      this.setState({
        next_10_days_initial_cleaning_data,
        next_10_days_table: Object.keys(next_10_days_initial_cleaning_data || {}).map((key) => ({
          area: key,
          ...next_10_days_initial_cleaning_data[key]
        })),
      })
    }
 
    //Add Initial 
    if (Object.keys(props.AddInitial.data).length > 0 && props.AddInitial.data !== this.props.AddInitial.data) {
      this.setState({
        loader: false,
        new_cleaning: {
          field_office_uuid: this.props.history.location.state.query.data.uuid || '',
          cleaning_date: '',
          repeat: false,
        }
      })
      this.props.getIntialCleaning({ field_office__uuid: this.props.history.location.state.query.data.uuid });
    }

    if (Object.keys(props.AddInitial.errors).length > 0 && props.AddInitial.errors !== this.props.AddInitial.errors) {
      errorHandle(props?.AddInitial?.errors)
      this.setState({
        loader: false,
      })
    }

    //Get Initial
    if (Object.keys(props.GetInitial.data).length > 0 && props.GetInitial.data !== this.props.GetInitial.data) {
      this.setState({
        calendar_data: props.GetInitial.data.results,
        loader: false,
      })

    }

    if (Object.keys(props.GetInitial.errors).length > 0 && props.GetInitial.errors !== this.props.GetInitial.errors) {
      errorHandle(props?.GetInitial?.errors)
      this.setState({
        loader: false,
      })
    }

    //Delete Initial
    if (Object.keys(props.DeleteInitial.data).length > 0 && props.DeleteInitial.data !== this.props.DeleteInitial.data) {
      this.setState({
        loader: false,
        is_delete: false,
        delete_id: ''
      })
      this.props.getIntialCleaning({ field_office__uuid: this.props.history.location.state.query.data.uuid });
    }

    if (Object.keys(props.DeleteInitial.errors).length > 0 && props.DeleteInitial.errors !== this.props.DeleteInitial.errors) {
      errorHandle(props?.DeleteInitial?.errors)
      this.setState({
        loader: false,
      })
    }




  }


  //Set Event on Calendar
  getListData(value) {
    let { calendar_data } = this.state;
    let listData = [];

    map(calendar_data, (item) => {
      switch (moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')) {
      case moment(item.cleaning_date, 'YYYY/MM/DD').format('DD/MM/YYYY'):
        listData.push({ uuid: item.uuid, date: moment(item, 'DD/MM/YYYY').format('DD/MM/YYYY'), content: 'Initial Cleaning Day.' })
        break;
      default:
      }
    })

    return listData || [];
  }

  //Render Event
  dateCellRender = (value) => {
    const listData = this.getListData(value);
    let scrollbarStyles = { borderRadius: 3.5 };
    return (

      <ScrollArea

        className="event-scroll"
        contentClassName="content"
        horizontal={false}
        speed={0.8}
        verticalScrollbarStyle={scrollbarStyles}
        verticalContainerStyle={scrollbarStyles}
        horizontalScrollbarStyle={scrollbarStyles}
        horizontalContainerStyle={scrollbarStyles}
        smoothScrolling={true}
        minScrollSize={40}
      >
        <ul className="events">
          {map(listData, (item, i) => {
            return (
              <li key={i}>
                <span>{item.content}
                  <i onClick={() => { this.setState({ is_delete: true, delete_id: item.uuid }) }} className="las la-times-circle"></i>
                </span>
              </li>
            )
          })}

        </ul>
      </ScrollArea>


    );
  }

  handleOutsideClick = (e) => {
    if(e?.path?.splice(5).some(item => !!item?.classList?.value?.includes('table_action_wrapper'))){
      return
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
      this.setState({
        openNav: {}
      })
    }
  }

  //show nav
  ShowNav = (record) => {
    if (!this.state.openNav[record.i]) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      openNav: {
        [record.i]: !prevState.openNav[record.i],
      },
      isNav: record.uuid
    }));
  }

  showZipcodeDrawer = (e) => {
    this.setState({
      is_zipcode_drawer: e,
    });
  }
  

  //Remove Event
  removeEvent = () => {
    let { delete_id } = this.state;
    this.props.deleteIntialCleaning(delete_id);
    this.setState({
      loader: true
    })
  }


  //Render Header for calendar
  headerRender = (e) => {
    return (
      <div className="calendar_header">
        <h5>{moment(e.value).format('MMM YYYY')}</h5>
        <div className="header_action">


          <span
            className="ico-btn"
            onClick={() => {
              const newValue = e.value.clone();
              e.onChange(new moment(newValue).subtract(1, 'months').date(1));

            }}
          ><i className="las la-angle-left"></i></span>

          <span
            className="ico-btn"
            onClick={() => {
              const newValue = e.value.clone();
              e.onChange(new moment(newValue).add(1, 'months').date(1));

            }}
          ><i className="las la-angle-right"></i></span>
        </div>
      </div>
    )
  }

  // Add Cleaning
  addInitialCleaning = () => {
    let { new_cleaning } = this.state;
    let data = { ...new_cleaning }
    this.setState({
      loader: true
    })


    this.props.addIntialCleaning(data);
  }

  toggleDrawer = (flg) => {
    if(!flg) {
      this.setState({
        is_zipcode_drawer: !this.state.is_zipcode_drawer,
      });
    } else {
      this.setState({
        is_zipcode_drawer: flg,
      });
    }
  }

  render() {
    let { loader, current_tab, is_zipcode_drawer } = this.state;
    return (
      <div className="initial_cleaning_wrapper">
        <div className="calendar_wrapper">
          <div className="mb-10 d-flex align-items-center justify-content-between int-clean-tabs">
            <ul className="tabs">
              <li
                onClick={() => {
                  this.setState({ current_tab: 0, 
                  })
                  this.props.setHideFooter(false)
                }}
                className={current_tab === 0 ? "active ml-0" : "ml-0"}
              >
                <span>SCHEDULE OF CLEANING</span>
              </li>
              <li
                onClick={() => {
                  this.setState({ 
                    current_tab: 1
                  });
                  this.props.setHideFooter(true);
                  this.props.getNextTenDaysInitialCleaningData({uuid: this.props.history.location.state.query.data.uuid})
                }}
                className={current_tab === 1 ? "active" : ""}
              >
                <span>NEXT 10 DAYS</span>
              </li>
                  
            </ul>
            <button onClick={() => {this.setState({selectedRecord: false}); this.toggleDrawer(true)}} className="btn btn-warning">Add New Area</button>
          </div>
          
          <div className="card">
            <div className="card-body">

              {/* <Calendar
                dateCellRender={this.dateCellRender}
                headerRender={this.headerRender}
              /> */}
              { current_tab === 0 ? 
                <Table 
                  rowKey={record => record.uuid}
                  dataSource={this.state?.table}
                  columns={DataTable.WeeklySchedule(this)}
                  className="table sched-clean"
                /> : 
                <Table 
                  rowKey={record => record.uuid}
                  dataSource={this.state?.next_10_days_table}
                  columns={DataTable.FutureSchedule(this)}
                  className="table"
                />
              }
            </div>
          </div>
        </div>
        <Drawer
          visible={is_zipcode_drawer}
          width={"420"}
          closable={false}
          className="drawer-wrapper create_ticket_drawer"
        >
          <ZipcodeDrawer
            data = {this.state.service_data}
            showZipcodeDrawer={() => {
              this.showZipcodeDrawer();
            }}
            {...{...this.props, ...this.state, initialCleaningToSaveRequest: this.initialCleaningToSaveRequest}}
          />
        </Drawer>
        
        {loader ? <Loader /> : ''}
        
      </div>
    );
  }
}

export default InitialCleaning;